import React, { Component } from "react";
import Modal from "react-modal";
import "../../../src/styles/modal.scss";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

export default class AlertWindow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    return (
      <div>
        <Modal
          className="Modal card"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldFocusAfterRender={false}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Example Modal"
        >
          <div className="Welcome-modal-container">
            <center>
              <h2>Gira sees everything!</h2>
              <img
                src={
                  localStorage.getItem("avatar") === "Koala"
                    ? koala
                    : localStorage.getItem("avatar") === "Fox"
                    ? fox
                    : localStorage.getItem("avatar") === "Lemur"
                    ? lemur
                    : localStorage.getItem("avatar") === "Zebra"
                    ? zebra
                    : koala
                }
                alt="angryGira"
                width="50%"
                height="50%"
              />

              <p className="Silly-text">
                Looks like you tried to <br /> Google the answer!
              </p>
            </center>

            <button
              className="cta-button"
              onClick={() => {
                this.closeModal();
                this.props.afterFocus();
              }}
            >
              Sorry!
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}
